import * as React from "react";

import { JoinDrawer } from "../../Common";

import {
  usePdpWishlistUserExperience,
  useReactPdpInitialState,
  WishlistUserExperience_Step,
} from "../providers";

import {
  useWishlistDrawerFragment,
  WishlistDrawerFragment,
} from "./wishlist-drawer-fragment";

export const PdpDrawer: React.FunctionComponent = () => {
  const {
    presentingUserExperienceStep:
      pdpWishlistUserExperience_presentingUserExperienceStep,
    handleCloseOfTheRightDrawerAtAnyTime:
      pdpWishlistUserExperience_handleCloseOfTheRightDrawerAtAnyTime,
  } = usePdpWishlistUserExperience();

  const {
    classNameForTheDrawer: pdpWishlistUserExperience_classNameForTheDrawer,
  } = useWishlistDrawerFragment(
    pdpWishlistUserExperience_presentingUserExperienceStep
  );

  const handleClose = React.useCallback(() => {
    pdpWishlistUserExperience_handleCloseOfTheRightDrawerAtAnyTime();
  }, [pdpWishlistUserExperience_handleCloseOfTheRightDrawerAtAnyTime]);

  const present = React.useMemo(() => {
    return (
      pdpWishlistUserExperience_presentingUserExperienceStep !==
        WishlistUserExperience_Step.NOT_PRESENTING &&
      pdpWishlistUserExperience_presentingUserExperienceStep !==
        WishlistUserExperience_Step.CLOSING
    );
  }, [pdpWishlistUserExperience_presentingUserExperienceStep]);

  const drawerClassName = React.useMemo(() => {
    return `${pdpWishlistUserExperience_classNameForTheDrawer}`;
  }, [pdpWishlistUserExperience_classNameForTheDrawer]);

  return (
    <JoinDrawer
      useInitialState={useReactPdpInitialState}
      present={present}
      drawerClassName={drawerClassName}
      handleClose={handleClose}
      allowJoining
    >
      <DrawerComposition />
    </JoinDrawer>
  );
};

const DrawerComposition: React.FunctionComponent = () => {
  return (
    <React.Fragment>
      <WishlistDrawerFragment />
    </React.Fragment>
  );
};
